module.exports = __webpack_public_path__ + "static/media/6_l_plita_1.46_77.96.76c871fa.png";